// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"4922d03c","849":"085d776d"}[chunkId] + ".chunk.js";
};